import { useEffect, useEffectEvent } from 'react';

type AutomationFailureRefreshListener = () => void;

const refreshListeners = new Set<AutomationFailureRefreshListener>();

export const emitAutomationFailureRefresh = () => {
  refreshListeners.forEach((listener) => listener());
};

export const useAutomationFailureRefresh = (onRefresh: AutomationFailureRefreshListener) => {
  const refresh = useEffectEvent(onRefresh);

  useEffect(() => {
    const listener = () => refresh();
    refreshListeners.add(listener);

    return () => {
      refreshListeners.delete(listener);
    };
  }, []);
};
